import { render } from "./InstallPromptComponent.vue?vue&type=template&id=fc05cb9a&scoped=true&ts=true"
import script from "./InstallPromptComponent.vue?vue&type=script&lang=ts"
export * from "./InstallPromptComponent.vue?vue&type=script&lang=ts"

import "./InstallPromptComponent.vue?vue&type=style&index=0&id=fc05cb9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc05cb9a"]])

export default __exports__